if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.thumbnails = this.querySelectorAll('.product-media-modal__thumb');
        this.prevButton = this.querySelector('.product-media-modal__nav--prev');
        this.nextButton = this.querySelector('.product-media-modal__nav--next');
        this.mediaContainer = this.querySelector('.product-media-modal__main');

        this.thumbnails.forEach((thumbnail) => {
          thumbnail.addEventListener('click', () => this.setActiveMedia(thumbnail.dataset.target));
        });

        if (this.prevButton) this.prevButton.addEventListener('click', () => this.step(-1));
        if (this.nextButton) this.nextButton.addEventListener('click', () => this.step(1));

        if (this.mediaContainer) {
          let touchStartX = 0;
          this.mediaContainer.addEventListener(
            'touchstart',
            (event) => {
              touchStartX = event.changedTouches[0].screenX;
            },
            { passive: true }
          );
          this.mediaContainer.addEventListener(
            'touchend',
            (event) => {
              const deltaX = event.changedTouches[0].screenX - touchStartX;
              if (Math.abs(deltaX) < 40) return;
              this.step(deltaX < 0 ? 1 : -1);
            },
            { passive: true }
          );
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      getMediaIds() {
        return Array.from(this.querySelectorAll('[data-media-id]')).map((element) =>
          element.getAttribute('data-media-id')
        );
      }

      step(direction) {
        const mediaIds = this.getMediaIds();
        if (!mediaIds.length) return;
        const activeMedia = this.querySelector('[data-media-id].active') || this.querySelector('[data-media-id]');
        const currentIndex = mediaIds.indexOf(activeMedia.getAttribute('data-media-id'));
        const nextIndex = (currentIndex + direction + mediaIds.length) % mediaIds.length;
        this.setActiveMedia(mediaIds[nextIndex]);
      }

      setActiveMedia(mediaId) {
        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.toggle('active', element.getAttribute('data-media-id') === mediaId);
        });

        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (activeMedia) {
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          if (
            activeMedia.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          )
            activeMedia.loadContent();
        }

        this.thumbnails.forEach((thumbnail) => {
          thumbnail.classList.toggle('is-active', thumbnail.dataset.target === mediaId);
        });
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        this.setActiveMedia(mediaId);

        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
      }
    }
  );
}
